/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, FC } from 'react'
import SIGNUP_STEPS from '../utils/constants'

const SignupContext = React.createContext({
  email: '',
  password: '',
  setSignupInfo: (email, password) => {},
  user: null,
  setUser: user => {},
  setSignupStep: user => {},
  signupStep: SIGNUP_STEPS.SIGNUP,
})
export { SignupContext }

const SignupContextContainer: FC = props => {
  const { children } = props
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [user, setUser] = useState(null)
  const [signupStep, setSignupStep] = useState(SIGNUP_STEPS.SIGNUP)
  const setSignupInfo = (signupEmail, signupPassword): void => {
    setEmail(signupEmail)
    setPassword(signupPassword)
    setSignupStep(SIGNUP_STEPS.CONFIRMATION)
  }
  return (
    <SignupContext.Provider
      value={{
        email,
        password,
        setSignupInfo,
        user,
        setUser,
        signupStep,
        setSignupStep,
      }}
    >
      {children}
    </SignupContext.Provider>
  )
}

export default SignupContextContainer
